import { delay } from "common/promises";
import { updateHTMLElement } from "common/screen";
/**
 * Open an image at the top while transition
 */
export class TransitionImage {
    constructor({ parent, imageURL }) {
        this.parent = parent;
        this.imageURL = imageURL;
        const randomNum = Math.floor(Math.random() * 1000000000);
        this.id = `transition-image-${randomNum}`;
        this._appendImage();
    }
    _appendImage() {
        const elem = $(`
    <div id="${this.id}" class="top-0 absolute">
    <div id="${this.id}-resizer" class="absolute">
    <img
      src="${this.imageURL}"
      class="absolute"
      id="${this.id}-body"
    </div>
</div>`);
        elem.hide();
        $(this.parent).append(elem);
        delay(0).then(() => {
            updateHTMLElement.base({
                selectorParent: `#${this.id}`,
                selectorChild: `#${this.id}-resizer`,
            });
        });
    }
    show() {
        $(`#${this.id}`).show();
    }
    appendSceneBeforeImage(element) {
        $(element).insertBefore(`#${this.id}`);
    }
    dispose() {
        $(`#${this.id}`).remove();
    }
}
//# sourceMappingURL=transitionImage.js.map